import React from 'react';

const colorSchemes = {
  primary: {
    bg: 'bg-primary',
    hoverBg: 'group-hover:bg-primary/90',
    text: 'text-white',
  },
  green: {
    bg: 'bg-green-500',
    hoverText: 'group-hover:text-green-500',
    selectedText: 'text-white',
  },
  red: {
    bg: 'bg-red-500',
    hoverText: 'group-hover:text-red-500',
    selectedText: 'text-white',
  },
};

const ChoiceButton = ({ text, icon: Icon, onClick, color = 'green', isSelected = false, disabled = false }) => {
  const scheme = colorSchemes[color];

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      className="group relative flex-1 flex items-center justify-center gap-2 px-5 py-3 rounded-full transition-all duration-200 disabled:opacity-50 disabled:cursor-not-allowed focus:outline-none focus-visible:ring-2 focus-visible:ring-primary"
    >
      <span
        className={`absolute inset-0 rounded-full transition-transform transform ${
          isSelected ? `${scheme.bg} scale-100` : 'bg-gray-500/20 dark:bg-white/20 scale-0 group-hover:scale-100'
        }`}
      ></span>
      {Icon && (
        <span className={`relative z-10 transition-colors ${isSelected ? scheme.selectedText : `${scheme.hoverText} text-content-secondary`}`}>
          <Icon className="h-5 w-5" />
        </span>
      )}
      <span className={`relative z-10 font-semibold transition-colors ${isSelected ? scheme.selectedText : 'text-content-primary'}`}>{text}</span>
    </button>
  );
};

export default ChoiceButton;
